export const auth = (state = { type: false, user: null }, action) => {
  if (action.type === 'FETCH_TOKEN') {
    return action.payload;
  }
  if (action.type === 'SET_NOTIFY_STATUS') {
    // Additive only: annotates the Notify menu's load state
    // ('loading' | 'ready' | 'down'). Never touches type/user/permissions, so
    // it cannot affect ERP auth or any other menu.
    return { ...state, notifyStatus: action.payload };
  }
  if (action.type === 'REMOVE_TOKEN') {
    return { type: false, user: null };
  }
  return state;
};
